import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {useNavigate} from 'react-router';
import CardInputGroup from '../../../../components/mazraeKit/CardInputGroup';
import classNames from 'classnames';
import {useDispatch, useSelector} from 'react-redux';
import {findAdvertisementList} from '../../../../store/redux/inputGroupAdvertisement';
import {RootState} from '../../../../store/redux';
interface CategoryItemProps {
  code: number;
  title: string;
  targetRoute: string;
  icon: string;
  inputListData: IInputLists[];
}
const CategoryItem = ({
  code,
  title,
  icon,
  targetRoute,
  inputListData,
}: CategoryItemProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const state = useSelector(
    (state: RootState) => state.inputGroupAdvertisement,
  );

  return (
    <div className="flex flex-col gap-3 w-100">
      <div className="flex justify-between items-center px-3 w-full">
        <div className="flex gap-2 items-center text-gray-700 text-md font-Medium">
          <SpanIcon className={classNames('text-[20px]', icon)} />
          <span>{title}</span>
        </div>
        <button
          className="flex gap-2 items-center text-sm font-Medium text-farm-shop-500"
          onClick={() =>
            navigate(`/advertisement_listing/${targetRoute}`, {
              state: null,
            })
          }
        >
          <span>مشاهده همه</span>
          <SpanIcon className="icon-nameArrow---Left-2 text-[20px]" />
        </button>
      </div>
      <div>
        <div className="grid grid-cols-4 px-3 w-full">
          {inputListData?.map(item => {
            return (
              <div className="flex justify-center w-full">
                <CardInputGroup
                  isActive={false}
                  isBoled={false}
                  title={item?.title}
                  image={item?.image}
                  guid={item?.guid}
                  clickHandler={() => {
                    navigate(
                      `/advertisement_listing/${targetRoute}/${item.title}`,
                      {
                        state: {selectedInput: item},
                      },
                    );
                    dispatch(
                      findAdvertisementList({
                        ...state,
                        input_guid: [{...item}],
                      }),
                    );
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryItem;
